import { render } from "./DashboardPassword.vue?vue&type=template&id=76813e02"
import script from "./DashboardPassword.vue?vue&type=script&lang=js"
export * from "./DashboardPassword.vue?vue&type=script&lang=js"
script.render = render

export default script